export const kSQL = Symbol("SQL");
export const kRedis = Symbol("Redis");
export const kCommands = Symbol("Commands");
export const kComponents = Symbol("Components");
export const kWebhooks = Symbol("Webhooks");
